export default {
  MEETING_API: `http://localhost:5001/confqa`,
  WSS: 'ws://localhost:3001',
  SIGNED_API: 'https://wjdgb55vp0.execute-api.us-east-1.amazonaws.com/confqa',
  STREAM_API: `http://localhost:5005/confqa`,
};
